module.exports = __webpack_public_path__ + "media/social/social-3-980e71f8.png";